import { AnimaAPI } from './api';
import { AnimaAuth } from './auth';
import { AnimaDB, AnimaEntityDB, createAnimaDB } from './db';
import { AnimaSettings } from './settings';

export type AnimaSDKParams = {
  authToken?: string;
  playgroundId?: string;

  // Overrides
  playgroundAPIBaseURL?: string;
  customAuthCallback?: (options: RequestInit) => RequestInit;
};

export class AnimaSDK {
  private auth: AnimaAuth;
  private api: AnimaAPI;
  private db: AnimaDB;
  private settings: AnimaSettings;

  constructor(public readonly params: AnimaSDKParams) {
    this.auth = new AnimaAuth({
      authToken: params.authToken,
    });
    this.api = new AnimaAPI({
      animaAuth: this.auth,
      playgroundId: params.playgroundId,
      playgroundAPIBaseURL: params.playgroundAPIBaseURL,
      customAuthCallback: params.customAuthCallback,
    });
    this.db = createAnimaDB({
      animaAPI: this.api,
    });
    this.settings = new AnimaSettings({
      playgroundId: params.playgroundId,
      playgroundAPIBaseURL: params.playgroundAPIBaseURL,
    });
  }

  getEntityDB(entityName: string): AnimaEntityDB {
    return this.db[entityName];
  }
}
